import {useState} from 'react';
import {CounterLabel, InfoLabel, SettingsLabel} from "../../../../config/Config";
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";

import Field from "../../Field";
import Alert from "../../../alert/Alert";
import Loading from "../../../generic/Loading";


const Counter = (props) => {
    const {journey, currentNode} = props
    const [loading, setLoading] = useState(false)


    const Information = {
        className: 'alert-primary',
        message: `Use this component to set a time lag before executing the next node. `,
        docs: {
            message: 'For more info, ',
            path: '/docs/journeys/counter/'
        }
    }

    const Id = {
        tab         : 'info',
        name        : 'id',
        type        : 'text',
        label       : 'Component Id',
        wrapper     : 'form-group',
        disabled    : true,
        canCopy     : true,
        defaultValue: currentNode.id,
        node        : currentNode,
    }

    const Title = {
        tab         : 'info',
        name        : 'title',
        type        : 'text',
        label       : 'Title',
        wrapper     : 'form-group',
        placeholder : 'Type an descriptive title',
        node        : currentNode,
        defaultValue: CounterLabel,
    }


    const Description = {
        tab        : 'info',
        name       : 'description',
        type       : 'textarea',
        label      : 'Description',
        wrapper    : 'form-group',
        className  : 'form-control',
        placeholder: 'Type a short description',
        node       : currentNode,
    }


    const Interval = {
        tab: 'settings',
        name: 'interval',
        type: 'number',
        wrapper: 'form-group field-counter-interval',
        placeholder: '15',
        node: currentNode,
    }


    const Periodicity = {
        inline: true,
        tab: 'settings',
        name: 'periodicity',
        type: 'radio',
        wrapper: 'form-group',
        options: [
            {
                hide: true,
                value: 'minutes',
                label: 'Minutes',
            },
            {
                hide: true,
                value: 'hours',
                label: 'Hours',
            },
            {
                hide: true,
                value: 'days',
                label: 'Days',
            }
        ],
        node: currentNode
    }


    return (
        <div>
            {loading && <Loading/>}
            {!loading && <div className="Form">
                <form className="FormComponent">
                    <div className="max-width-500">
                        <Alert {...Information} />

                        <div className="FieldsetTabs">
                            <Tabs defaultActiveKey="0">
                                <TabPane forceRender={true} key={'tab_settings'} tabKey={'tab_settings'} tab={SettingsLabel}>
                                    <label className="Label">
                                        <span className="text-red required">* </span>
                                        Choose Interval
                                    </label>
                                    <div className="d-flex v-align">
                                        <Field {...Interval}/>
                                        <Field {...Periodicity}/>
                                    </div>
                                </TabPane>
                                <TabPane forceRender={true} key={'tab_info'} tabKey={'tab_info'} tab={InfoLabel}>
                                    <div>
                                        <Field {...Id}/>
                                        <Field {...Title}/>
                                        <Field {...Description}/>
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </form>
            </div>}
        </div>
    )
}

export default Counter;